export default __webpack_public_path__ + "static/media/sony.c92514b2.png";